import { cloneDeep, useQuery } from '@graphcommerce/graphql'
import { ProductListSortFragment } from '@graphcommerce/magento-product/components/ProductListSort/ProductListSort.gql'
import { useProductListParamsContext } from '@graphcommerce/magento-product/hooks/useProductListParamsContext'
import { StoreConfigDocument } from '@graphcommerce/magento-store'
import { i18n } from '@lingui/core'
import { MenuItem } from '@mui/material'
import { useCallback } from 'react'
import { useProductListLinkReplace } from '../../../hooks/Product/useProductListLinkReplace'
import { StandardDropdown } from '../../Dropdown/StandardDropdown'

export type ProductListSortProps = ProductListSortFragment & {
  className?: string
  isCollectionPage?: boolean
}

export function ProductListSort(props: ProductListSortProps) {
  const { sort_fields, total_count, className = '', isCollectionPage } = props
  const { params } = useProductListParamsContext()
  const replaceRoute = useProductListLinkReplace()
  const { data: storeConfigQuery } = useQuery(StoreConfigDocument)
  const defaultSort = storeConfigQuery?.storeConfig?.catalog_default_sort_by

  const [currentSort = defaultSort] = Object.keys(params.sort)

  const handleSortChange = useCallback(
    (option) => {
      const linkParams = cloneDeep(params)
      linkParams.sort = {}
      linkParams.sort[option ?? ''] = 'DESC'
      delete linkParams.currentPage
      replaceRoute(linkParams)
    },
    [replaceRoute, params],
  )

  if (!total_count) return null

  const sortOptions = sort_fields?.options
    ?.map((option) => {
      if (option?.value === 'production_time') {
        return {
          ...option,
          label: i18n._(/* i18n */ 'Quick ship'),
        }
      }
      return option
    })
    .filter((option) => option?.value && !['position'].includes(option?.value))

  const menuItems = sortOptions?.map((option, index) => (
    <MenuItem value={option?.value ?? index} className='flex w-full items-center justify-between'>
      <span>{option?.label}</span>
    </MenuItem>
  ))

  if (!isCollectionPage) {
    menuItems?.unshift(
      <MenuItem value='relevance' className='flex min-h-[30px] w-full items-center justify-between'>
        <span>Relevance</span>
      </MenuItem>,
    )
  }

  return (
    <div
      className={`z-10 flex justify-start gap-[22px] py-[20px] md:justify-between md:py-0 ${className}`}
    >
      <StandardDropdown
        label='Sort By'
        onChange={(option) => {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
          handleSortChange(option?.target?.value)
        }}
        options={menuItems}
        sx={{
          width: '260px',
          maxWidth: '260px',
        }}
        defaultValue={isCollectionPage ? defaultSort : 'relevance'}
      />
      {/* {sortOptions?.map((option) => (
        <button
          key={option?.value ?? ''}
          type='button'
          className={`md:Type-Large-Medium Type-Large-Medium px-[5px] pb-2 uppercase  md:px-[10px] ${
            option?.value === currentSort
              ? 'border-b-[3px] font-bold text-material-ui-blue hover:border-material-ui-dark-blue hover:text-material-ui-dark-blue'
              : 'text-black/60 hover:text-black'
          }`}
          onClick={() => handleSortChange(option)}
        >
          {option?.label}
        </button>
      ))} */}
    </div>
  )
}
